import Image from 'next/image';
import { getReadableImageUrl } from '@/lib/directus'
import { sanitizeHTML } from '@/lib/utils'
interface SecBgTextProps {
	heading?: {
		title?: string
	}
	text?: {
		text?: string
	}
	background_desktop?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_download: string
			}
		}
	}
	background_mobile?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_download: string
			}
		}
	}
}

export function getSecBgId(instanceIndex = 1) {
	return instanceIndex <= 1 ? 'SecBg' : `SecBg${instanceIndex}`
}

export const fields = [
	'heading.title',
	'text.text',
	'background_desktop.alt',
	'background_desktop.image_file.image.id',
	'background_desktop.image_file.image.filename_download',
	'background_mobile.alt',
	'background_mobile.image_file.image.id',
	'background_mobile.image_file.image.filename_download',
]
export default function SecBgText({
	data,
	instanceIndex = 1,
}: {
	data: SecBgTextProps
	instanceIndex?: number
}) {
  return (
		<>
			<section
				id={getSecBgId(instanceIndex)}
				className='SecBgText relative overflow-hidden py-[8rem] max-md:py-0 bg-neutral-50 max-md:rounded-tl-[50px]'
			>
				{/* Background Image */}
				<picture className='absolute inset-0 z-0 w-full h-full max-md:relative max-md:h-[380px] max-md:block'>
					<source
						srcSet={getReadableImageUrl(
							data?.background_desktop?.image_file?.image?.id || '',
							data?.background_desktop?.image_file?.image?.filename_download ||
								''
						)}
						media='(min-width: 580px)'
						type='image/webp'
					/>
					<Image
						src={getReadableImageUrl(
							data?.background_mobile?.image_file?.image?.id || '',
							data?.background_mobile?.image_file?.image?.filename_download ||
								''
						)}
						alt={data?.background_mobile?.alt || ''}
						fill
						sizes='100vw'
						className='object-cover object-top'
						priority
					/>
				</picture>

				<div className='container relative'>
					<div className='flex flex-col lg:flex-row max-md:py-12'>
						{/* Content Box */}
						<div className='w-full lg:w-1/2 flex flex-col gap-8 relative z-10'>
							<h2>{data?.heading?.title || ''}</h2>
							<div className='grid gap-8' dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')} />
							</div>
						</div>
				</div>
			</section>
		</>
	)
} 